<template>
  <div>
    <!-- <mheader></mheader> -->
       <div v-show="tableData.length>0" style="width:1300px;margin:0 auto;" id="v-content" :style="{minHeight:Height+'px'}">
        <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888;">
              <p class="mt-2 ml-2 mb-2">
                  <span class="p-1" style="font-size:18px;text-shadow:#000 1px 0 0;background-color:#3190e8;color:#fff;box-shadow: 6px 4px 9px #888888;font-family: Helvetica Neue,Tahoma,Arial;border-radius:3px;">
                      流失客户
                  </span>
                  <span class="ml-5">
                     （近三个月）
                  </span>
                
                   <span class="ml-5">
                          <span>
                              显示<span class="record">{{PageNo}}</span>-<span class="record">{{Pcount}}</span>页,
                          </span>
                          <span>
                              总共<span class="record">{{Record}}</span>条数据
                          </span> 
                   </span>
                   <span class="float-right span_close mr-1" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                   </span>
                   <button class="btn btn-primary ml-5" style="font-size:10px;" @click="NewCustomer()">
                         查询新增客户
                   </button>
                </p>
                <p>
                     <!-- <ol class="breadcrumb">
                         <li><a href="#" :class="{active:show==1}" @click="getday(1)">当天</a></li>
                         <li><a href="#" :class="{active:show==2}" @click="getmounth(2)">当月</a></li>
                         <li><a href="#" :class="{active:show==3}" @click="getyear(3)">当年</a></li>
                    </ol> -->
                </p>
              <div>
                <table class="table table-striped table-hover sett"  ref="print">
                <thead>
                  <tr style="white-space:nowrap;" @click="changeWidth($event)">
                      <th class="text-center">客户编号</th>
                      <th class="text-center">客户名称</th>
                      <th class="text-center">创建时间</th>
                      <th class="text-center">省份</th>
                      <th class="text-center">市</th>
                      <th class="text-center">县/区</th>
                  </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in tableData" :key="index" style="white-space:nowrap;">
                      <td class="text-center">{{item.customerNum}}</td>
                      <td class="text-center">{{item.customerName}}</td>
                      <td class="text-center">{{item.createDate | formatUTC}}</td>
                      <td class="text-center">{{item.province}}</td>
                      <td class="text-center">{{item.city}}</td>
                      <td class="text-center">{{item.area}}</td>
                </tr>
                </tbody>
              </table>
              </div>      
              <!-- 分页 -->
                             <div class="row m-0 mb-3">
                                       <nav aria-label="Page navigation" style="text-align:center;" v-if="this.Pcount!==0" class="mb-1">
                                                                <ul class="pagination">
                                                                <li class="page-item ml-5" :class="PageNo<=1?'disabled':''" @click="prePage()">
                                                                    <a aria-label="Previous" class="page-link">
                                                                    <span aria-hidden="true">&laquo;</span>
                                                                    </a>
                                                                </li>
                                                                    <li :class="index==PageNo?'active':''" class="page-item" v-for="index of Pcount" :key="index"
                                                                                                        @click="curPage(index)">
                                                                                                        <a class="page-link" v-if="index<=20">{{index}}</a>
                                                                                                        <a class="page-link" v-if="index>20 && index==(Pcount-1)">...</a>
                                                                                                        <a class="page-link" v-if="index>20 && index==Pcount">{{Pcount}}</a>
                                                                                                    </li>
                                                                <li class="page-item" :class="PageNo>=Pcount?'disabled':''" @click="nextPage()">
                                                                    <a aria-label="Next" class="page-link">
                                                                    <span aria-hidden="true">&raquo;</span>
                                                                    </a>
                                                                </li>
                                                                </ul>
                                                            </nav>
                             </div>
                                     <p class="text-center">
                                        <!-- <img src="../../static/images/tuding.png" style="width:1.5rem;height:1.5rem;" alt=""/> -->
                                    </p>
                     
                       <!-- <div class="row p-0 m-0">        
                                <p>
                                       <span>
                                                    查询数量总计：<span class="money">¥{{totalNum}}</span>
                                      </span>
                                      <span>
                                                    (真实)销售金额总计: <span class="money">¥{{totalMoney}}</span>
                                      </span>
                                      <span>
                                                  (真实)费用合计: <span class="money">¥{{feeMoney}}</span>
                                      </span>
                                     
                                       <span>
                                            显示<span class="record">{{PageNo}}</span>-<span class="record">{{Pcount}}</span>条,
                                      </span>
                                      <span>
                                           总共<span class="record">{{Record}}</span>条数据
                                      </span> 
                                  
                                </p>                                                                                                   
                       </div> -->
            </div>
       </div>

            <div v-show="Pcount===0" style="width:1300px;margin:0 auto;" id="v-content" :style="{minHeight:Height+'px'}">
        <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888;">
              <p class="mt-2">
                  <!-- <img src="../../static/images/kucun_1.png" style="width:1.5rem;height:1.5rem;" class="mb-lg-1" alt=""/> -->
                  <span class="p-1" style="text-shadow:#000 1px 0 0;background-color:#3190e8;color:#fff;box-shadow: 6px 4px 9px #888888;font-family: Helvetica Neue,Tahoma,Arial;border-radius:3px;">
                      结算查询
                  </span>
                   <span class="ml-5">
                          <span>
                              显示<span class="record">{{PageNo}}</span>-<span class="record">{{Pcount}}</span>页,
                          </span>
                          <span>
                              总共<span class="record">{{Record}}</span>条数据
                          </span> 
                   </span>
                   <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                   </span>
                </p>
              
           
                               <img src="../../../static/images/wushuju.jpg" style="width:300px;height:300px;display:block;margin:0 auto;" alt="">
                                     <p class="text-center">
                                        <!-- <img src="../../static/images/tuding.png" style="width:1.5rem;height:1.5rem;" alt=""/> -->
                                    </p>
                     
                       <!-- <div class="row p-0 m-0">        
                                <p>
                                       <span>
                                                    查询数量总计：<span class="money">¥{{totalNum}}</span>
                                      </span>
                                      <span>
                                                    (真实)销售金额总计: <span class="money">¥{{totalMoney}}</span>
                                      </span>
                                      <span>
                                                  (真实)费用合计: <span class="money">¥{{feeMoney}}</span>
                                      </span>
                                     
                                       <span>
                                            显示<span class="record">{{PageNo}}</span>-<span class="record">{{Pcount}}</span>条,
                                      </span>
                                      <span>
                                           总共<span class="record">{{Record}}</span>条数据
                                      </span> 
                                  
                                </p>                                                                                                   
                       </div> -->
            </div>
       </div>

    <!-- 表单内容 -->
            <div>
              <transition name="fade">
                <loading v-if="isLoading"></loading>
              </transition>
            </div>
   
    <!-- Footer -->
    <!-- <mfooter></mfooter> -->
  </div>
</template>
<script>
  // import mheader from '../components/Header.vue'
  // import mfooter from '../components/Footer.vue'
  // import Loading from '../components/Loading.vue'

  export default {
    name: 'SaleQuery',
    data() {
      return {
         Height:0,
        searchData: [],//搜索返回的清单
        isLoading: false,
        tableData: [],
        Record: '',//总记录数
        Pcount: '',//总页数
        PageNo: 1, //当前页码
        totalNum:"",
        totalMoney:'',
        feeMoney:'',
        show:1,
        dataType:1,
      }
    },
    components: {
      // mheader,
      // mfooter,
      // Loading,

      
    },
    computed: {},
    filters: {
      getTrue:function(result) {
             if(result){
              
             return "是"
             }
             if(!result){
            
               return "否"
             }
             
        } ,
         formatUTC: function (utc_datetime) {
           return utc_datetime.replace(/T/ig,"  ").substring(0,20)
      },
   },
    methods: {
        //改变类型
      //  getday(state){
      //       this.dataType=state
      //       this.show=1
      //       this.getNewcustomer()
      //  },
      //  getmounth(state){
      //        this.dataType=state
      //        this.show=2
      //        this.getNewcustomer()
      //  },
      //  getyear(state){
      //       this.dataType=state
      //       this.show=3
      //       this.getNewcustomer()
      //  },
      //改变宽度
      changeWidth:function(e){
              
      },
      NewCustomer:function(){
               this.$router.push({path: '/newCustomer'})
        },
      getNewcustomer: async function (PageIndex) {
        // this.isLoading=true;
        this.PageNo = PageIndex || this.PageNo
        const {data: res} = await this.$http.post('Dls/getFun', {
          action:'LostCustomer',
          obj: JSON.stringify({
            PageIndex,
            PageSize: 20,
            dataType:this.dataType,
          })
        })
        // console.log(res)
        if (res.isok) {
          const obj = res.data
          this.tableData = obj.rows
          this.Pcount = obj.pcount
          this.Record = obj.record
          this.totalNum = obj.totalNum
          this.totalMoney =obj.totalMoney
          this.feeMoney = obj.feeMoney
       
        }
      },
      // 当前页
        curPage: function (index) {
        
           this.getNewcustomer(index)
        
      },
      //上一页
      prePage: function () {
        if (this.PageNo > 1) {
          this.PageNo--;
          

            this.getNewcustomer(this.PageNo);
          
        }
      },
      //下一页
      nextPage: function () {
        if (this.PageNo < this.Pcount) {
          this.PageNo++;
          

            this.getNewcustomer(this.PageNo);
          
        }
      },
      //搜索功能
      // 打印
      start_print() {
        this.$print(this.$refs.print);//$refs的值要和html里的ref一致
      }

    },
     mounted(){
          //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.Height = document.documentElement.clientHeight - 100;  
　　//监听浏览器窗口变化　
    window.onresize = ()=> {this.Height = document.documentElement.clientHeight -100}
  
    },
    created() {
      this.getNewcustomer();

    }
  }
</script>
<style scoped>
  .table-hover > tbody > tr:hover {
    background-color: #dee2e6 !important;
  }
  .money{
      color:red;
      font-weight: 500;
  }
  .record{
      color:green;
      font-weight: 500;
  }
  .sett{
        width:1300px;
        table-layout:fixed;
       
  }
  .sett-td {

    white-space:nowrap;

    overflow:hidden;

    text-overflow:ellipsis;

   -moz-text-overflow: ellipsis; 

}
.autocut{
     overflow:hidden;
      white-space:nowrap;
      text-overflow:ellipsis;
      -o-text-overflow:ellipsis;
     -khtml-text-overflow: ellipsis;
     -moz-text-overflow: ellipsis;
    -webkit-text-overflow: ellipsis;
}
 .autocut:hover
 {
     overflow:visible;
     width:200px;
     white-space:nowrap;
     word-wrap: break-word;
     text-align:center;
 }
 .span_close:hover{
       color:#3190e8;
 }
 .breadcrumb > li + li:before {
    color: #CCCCCC;
    content: "/ ";
    padding: 0 5px;
}
.active{
   border:1px solid #3190e8;
   background-color:#3190e8;
   border-radius:3px;
   color:#fff;
 }
</style>


// WEBPACK FOOTER //
// src/pages/manager/LossingCustomer.vue